import { store } from '@/store/store'

export const requestBody = {

  getRequestBody ({ methodName, methodParameters }) {
    methodParameters = JSON.parse(JSON.stringify(methodParameters))
    if (this[methodName + 'RequestBody']) {
      return this[methodName + 'RequestBody']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  initRequestBody ({ methodParameters }) {
    let merchantName = store.getters.dpaId.displayDpaName
    let { srciTransactionId, dpaTransactionOptions, sdkSpecificParameters } = methodParameters
    let specificParameters = sdkSpecificParameters.amex
    let sdkSpecificDpaTransactionOptions = specificParameters.dpaTransactionOptions
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    let finalRequestBody = {
      srciTransactionId,
      srcInitiatorId: specificParameters.srcInitiatorId,
      srciDpaId: specificParameters.srcDpaId,
      dpaData: { dpaPresentationName: merchantName },
      dpaTransactionOptions
    }
    if (specificParameters.host !== '') {
      finalRequestBody.host = specificParameters.host
    }
    return finalRequestBody
  },

  identityLookupRequestBody ({ methodParameters }) {
    let consumerIdentity = { ...methodParameters.consumerIdentity }
    let _identityType = consumerIdentity.identityType
    delete consumerIdentity.identityType
    consumerIdentity.type = _identityType === 'EMAIL_ADDRESS' ? 'EMAIL' : 'MOBILE_NUMBER'
    if (consumerIdentity.type === 'MOBILE_NUMBER') {
      let { mobileNumber } = consumerIdentity.identityValue
      consumerIdentity.identityValue = mobileNumber.countryCode + '' + mobileNumber.phoneNumber
    } else {
      consumerIdentity.identityValue = consumerIdentity.identityValue.email
    }
    return consumerIdentity
  },

  initiateIdentityValidationRequestBody ({ methodParameters }) {
    return {}
  },

  completeIdentityValidationRequestBody ({ methodParameters }) {
    return methodParameters.validationData
  },

  getSrcProfileRequestBody ({ methodParameters }) {
    let { idTokens } = methodParameters
    return idTokens
  },

  checkoutRequestBody ({ methodParameters }) {
    let { dpaTransactionOptions, sdkSpecificDpaTransactionOptions } = methodParameters
    let complianceSettings
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    delete methodParameters.network
    delete methodParameters.dpaTransactionOptions
    delete methodParameters.sdkSpecificDpaTransactionOptions
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
    } else {
      complianceSettings = store.getters.complianceSettingsObj
    }
    return { ...methodParameters, dpaTransactionOptions, complianceSettings }
  },

  unbindAppInstanceRequestBody ({ methodParameters }) {
    return [ methodParameters.idToken ]
  },

  getDpaTransactionOptions ({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions }) {
    dpaTransactionOptions = {
      ...dpaTransactionOptions,
      ...sdkSpecificDpaTransactionOptions,
      isGuestCheckout: false
    }
    dpaTransactionOptions.CustomInputData = { 'checkoutType': store.getters.amexDcfPreference }
    delete dpaTransactionOptions.customInputData
    delete dpaTransactionOptions.payloadTypeIndicatorCheckout
    delete dpaTransactionOptions.payloadTypeIndicatorPayload
    delete dpaTransactionOptions.threeDsPreference
    delete dpaTransactionOptions.confirmPayment
    delete dpaTransactionOptions.paymentOptions.dpaDynamicDataTtlMinutes
    return dpaTransactionOptions
  }
}
